var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlogging(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-8"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 429.83,
    y: 398.49,
    width: 20.07,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357.48,
    y: 394.99,
    width: 32.02,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274.19,
    y: 389.21,
    width: 36.98,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.46,
    y: 396.57,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.22,
    y: 396.57,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.75,
    y: 389.08,
    width: 37.48,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.23,
    y: 80.75,
    width: 70.62,
    height: 96.09,
    transform: "translate(197.09 257.58) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.22,
    y: 80.75,
    width: 70.62,
    height: 96.09,
    transform: "translate(191.06 257.58) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.48,
    y: 98.89,
    width: 86.09,
    height: 59.79,
    transform: "translate(224.32 33.26) rotate(90)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.72,
    y: 127.65,
    width: 86.09,
    height: 2.28,
    transform: "translate(195.56 62.02) rotate(90)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.46,
    y: 141.84,
    width: 66.14,
    height: 6.71,
    transform: "translate(191.06 290.39) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.21,
    y: 80.75,
    width: 70.62,
    height: 96.09,
    transform: "translate(401.04 257.58) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.19,
    y: 80.75,
    width: 70.62,
    height: 96.09,
    transform: "translate(395.01 257.58) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.46,
    y: 98.89,
    width: 86.09,
    height: 59.79,
    transform: "translate(326.3 -68.71) rotate(90)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.7,
    y: 127.65,
    width: 86.09,
    height: 2.28,
    transform: "translate(297.54 -39.96) rotate(90)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.43,
    y: 141.84,
    width: 66.14,
    height: 6.71,
    transform: "translate(395.01 290.39) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.19,
    y: 80.75,
    width: 70.62,
    height: 96.09,
    transform: "translate(604.99 257.58) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.17,
    y: 80.75,
    width: 70.62,
    height: 96.09,
    transform: "translate(598.96 257.58) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.43,
    y: 98.89,
    width: 86.09,
    height: 59.79,
    transform: "translate(428.27 -170.69) rotate(90)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.68,
    y: 127.65,
    width: 86.09,
    height: 2.28,
    transform: "translate(399.51 -141.93) rotate(90)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266.41,
    y: 141.84,
    width: 66.14,
    height: 6.71,
    transform: "translate(598.96 290.39) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 369.16,
    y: 80.75,
    width: 70.62,
    height: 96.09,
    transform: "translate(808.94 257.58) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.15,
    y: 80.75,
    width: 70.62,
    height: 96.09,
    transform: "translate(802.91 257.58) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.41,
    y: 98.89,
    width: 86.09,
    height: 59.79,
    transform: "translate(530.25 -272.66) rotate(90)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.65,
    y: 127.65,
    width: 86.09,
    height: 2.28,
    transform: "translate(501.49 -243.91) rotate(90)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 368.39,
    y: 141.84,
    width: 66.14,
    height: 6.71,
    transform: "translate(802.91 290.39) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.22,
    y: 279.67,
    width: 46.67,
    height: 102.73,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "232.43 265.51 219.75 382.4 368.5 382.4 381.18 265.51 232.43 265.51",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "230.05 265.51 217.37 382.4 366.12 382.4 378.8 265.51 230.05 265.51",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.22 372.61 357.39 372.61 367.95 275.3 238.78 275.3 228.22 372.61",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.86,324.62l15.92,17.86c8,9,22.63,9,32.59,0l19.79-17.86a1,1,0,0,0,.15-1.33l-15.92-17.86c-8-9-22.63-9-32.59,0L264,323.29A1,1,0,0,0,263.86,324.62Zm66.38-.67-19.06,17.2c-9.15,8.25-22.57,8.25-29.93,0L265.92,324,285,306.76c9.15-8.25,22.58-8.25,29.93,0Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.82,
    y: 248.95,
    width: 24.64,
    height: 133.45,
    transform: "translate(318.28 631.35) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.34,
    y: 248.95,
    width: 79.48,
    height: 133.45,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.15,
    y: 284.33,
    width: 127.85,
    height: 68.29,
    transform: "translate(425.55 211.4) rotate(90)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.22,
    y: 306.4,
    width: 127.85,
    height: 24.15,
    transform: "translate(447.62 189.33) rotate(90)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.44,304.28a4.76,4.76,0,0,0,3.42-8.08c-2.18-2.22-5.69-4-11.32-4s-9.13,1.8-11.32,4a4.76,4.76,0,0,0,3.43,8.08Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115,302.51a3.06,3.06,0,0,0,2.2-5.19c-1.41-1.42-3.66-2.58-7.27-2.58s-5.87,1.16-7.27,2.58a3.06,3.06,0,0,0,2.2,5.19Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.94,304.13a4.33,4.33,0,0,0,3.11-7.35c-2-2-5.18-3.67-10.3-3.67s-8.32,1.65-10.3,3.67a4.33,4.33,0,0,0,3.11,7.35Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.35,300.2a3.29,3.29,0,0,1,2.71,5.14c-3,4.5-10.61,10.34-29.42,10.34s-26.39-5.84-29.43-10.34a3.29,3.29,0,0,1,2.72-5.14Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.76,
    y: 282.81,
    width: 5.6,
    height: 71.32,
    transform: "translate(424.03 212.91) rotate(90)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "132.29 248.95 150.16 248.95 144.86 202.99 132.29 202.99 132.29 248.95",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "102.12 248.95 141.87 248.95 146.06 195.15 106.31 195.15 102.12 248.95",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.26 248.95 140.62 248.95 144.82 195.15 103.46 195.15 99.26 248.95",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "136.71 244.71 140.25 199.39 107.37 199.39 103.83 244.71 136.71 244.71",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-8"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-8",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.37,220.41l4.67-.21-2.11,8.86a24.53,24.53,0,0,1-4.52-4,2.26,2.26,0,0,1,.24-3.17Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "163.45 224.98 161.36 232.21 155.93 229.06 158.04 220.2 163.45 224.98",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.83,169.23c1.89,4.19,3.87,8.49,5.87,12.68s4,8.4,6.22,12.41c.53,1,1.1,2,1.65,3l.11.19s0,0,0,0,0,0-.09-.07a3.19,3.19,0,0,0-1-.65,2.81,2.81,0,0,0-.58-.19,3.26,3.26,0,0,0-.69-.09,3.45,3.45,0,0,0-1.27.18,2.28,2.28,0,0,0-1,.59c-.14.19.09,0,.29-.26a10.1,10.1,0,0,0,.68-1.07c.47-.83,1-1.8,1.39-2.8,1.76-4,3.34-8.55,4.91-12.93l5.35,1a75,75,0,0,1-2.16,14.71,32.53,32.53,0,0,1-1.22,3.84,21,21,0,0,1-1,2.09,10.38,10.38,0,0,1-1.89,2.54,6.74,6.74,0,0,1-2.51,1.52,6.09,6.09,0,0,1-2.15.29,6.28,6.28,0,0,1-1.13-.16,6.51,6.51,0,0,1-1-.33,7.12,7.12,0,0,1-2.41-1.74,9.28,9.28,0,0,1-.64-.78l-.25-.35-.13-.19c-.7-1-1.41-2.07-2.07-3.12-2.66-4.18-5-8.44-7.25-12.75s-4.25-8.67-6.15-13.21Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.46,178.69l1.09-3.52,7,3s-1.47,3.85-4,5.42a2.25,2.25,0,0,1-3.1-.69h0A6.56,6.56,0,0,1,213.46,178.69Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216,169.73l1.12.32a6.25,6.25,0,0,1,4.51,6.22l-.07,1.87-7-3Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.79,180.47l-6.17-.61a.62.62,0,0,1-.55-.72l2-13.27a.71.71,0,0,1,.76-.59l6.16.61a.61.61,0,0,1,.56.72l-2,13.27A.72.72,0,0,1,217.79,180.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.47,180.44l-6.16-.61a.63.63,0,0,1-.56-.72l2-13.27a.7.7,0,0,1,.76-.59l6.16.61a.63.63,0,0,1,.56.72l-2,13.27A.71.71,0,0,1,217.47,180.44Z",
    style: {
      fill: "#F68989"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "218.36 179 210.88 178.27 212.59 167.04 220.07 167.78 218.36 179",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "212.35 178.41 211.43 178.32 215.69 167.35 216.61 167.44 212.35 178.41",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "214.34 178.61 212.9 178.47 217.16 167.5 218.61 167.64 214.34 178.61",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.9,166.48a.46.46,0,0,1-.48.37.4.4,0,0,1-.35-.45.46.46,0,0,1,.48-.38A.41.41,0,0,1,216.9,166.48Z",
    style: {
      fill: "#263238",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.51,176.18l-1.09.37-1-.92a7.51,7.51,0,0,0-1.7-1.21l-.52-.27-.28.35a1.13,1.13,0,0,0-.06,1.37l.59.85,2,4.55,2-.55,1.63-2.11Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.69,172.79c-1.15,2-2.42,4.13-3.55,6.25s-2.28,4.28-3.32,6.44-2,4.34-2.91,6.52a54.39,54.39,0,0,0-2.2,6.52l-.36,1.37a3.16,3.16,0,0,0-.07.82,9.27,9.27,0,0,0,.45,2.5,30.05,30.05,0,0,0,2.74,5.95c1.15,2,2.49,4,3.89,6s2.91,4,4.38,5.86L153,225a64.43,64.43,0,0,1-11.45-11.13,34.17,34.17,0,0,1-4.53-7.33,18.65,18.65,0,0,1-1.42-4.83,13.13,13.13,0,0,1-.07-3l.09-.78.09-.52.19-1.05c.22-1.43.58-2.75.9-4.11s.75-2.64,1.2-3.91c.84-2.58,1.85-5,2.91-7.49s2.23-4.79,3.48-7.11q.93-1.74,1.92-3.45c.66-1.17,1.32-2.24,2.11-3.45Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.65,141.54c-.19.55-.06,1.11.3,1.25s.8-.2,1-.75.06-1.11-.3-1.25S186.84,141,186.65,141.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.54,142.63a21.9,21.9,0,0,0,1,5.74,3.3,3.3,0,0,1-2.77-.52Z",
    style: {
      fill: "#ed893e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.58,138.28a.34.34,0,0,1-.18-.09,2.72,2.72,0,0,0-2.42-.46.34.34,0,0,1-.42-.24.34.34,0,0,1,.24-.42,3.4,3.4,0,0,1,3.06.61.35.35,0,0,1,0,.49A.38.38,0,0,1,188.58,138.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.86,143.2c.19,6,2.4,13.17-1.17,16.71,0,0,1.66,5.37,11.5,5.37,10.83,0,5-5.37,5-5.37-6-1.41-6-5.8-5.11-9.92Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.15,161.75c-.84-1.7-1.71-4.32,0-4.93,1.91-.67,11.68-2.37,19.1,0a6.48,6.48,0,0,0-.1,5.3Z",
    style: {
      fill: "#F68989"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.57,409.21a9.13,9.13,0,0,1-1.89-.2.17.17,0,0,1-.13-.14.15.15,0,0,1,.07-.17c.08-.06,2-1.41,3.08-1.19a.84.84,0,0,1,.56.4.7.7,0,0,1,0,.82A2.27,2.27,0,0,1,154.57,409.21Zm-1.42-.46c1.09.19,2.57.18,2.87-.22,0,0,.12-.16-.05-.44a.49.49,0,0,0-.35-.24A4.6,4.6,0,0,0,153.15,408.75Z",
    style: {
      fill: "#F68989"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.72,409l-.09,0a.18.18,0,0,1-.09-.16c0-.09.1-2.17.91-2.87a.94.94,0,0,1,.73-.22.56.56,0,0,1,.56.46c.16.81-1.22,2.39-1.94,2.79Zm1.34-2.94a.54.54,0,0,0-.38.16,4,4,0,0,0-.77,2.27c.71-.56,1.59-1.75,1.5-2.23,0,0,0-.16-.27-.19Z",
    style: {
      fill: "#F68989"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.66,409.21a13.12,13.12,0,0,1-2.23-.2.17.17,0,0,1-.13-.14.18.18,0,0,1,.08-.18c.36-.21,3.58-2.05,4.36-.78a.65.65,0,0,1,0,.76C194.48,409.08,193.59,409.21,192.66,409.21Zm-1.68-.46c1.36.19,3.2.17,3.51-.28,0,0,.1-.14-.05-.38C194,407.37,192.05,408.19,191,408.75Z",
    style: {
      fill: "#F68989"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.47,409a.17.17,0,0,1-.1,0,.15.15,0,0,1-.07-.15c0-.08.12-2,1-2.79a1.2,1.2,0,0,1,.95-.3c.48.05.62.29.65.49.14.84-1.5,2.37-2.37,2.77Zm1.65-2.94a.89.89,0,0,0-.59.23,3.92,3.92,0,0,0-.86,2.24c.87-.53,2-1.75,1.91-2.25,0-.05,0-.18-.36-.21Z",
    style: {
      fill: "#F68989"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "182.5 408.84 189.75 408.84 189.82 392.06 182.57 392.06 182.5 408.84",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "144.41 408.84 151.66 408.84 154.65 392.06 147.41 392.06 144.41 408.84",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.14,408H144a.62.62,0,0,0-.6.5l-1.18,6.44a1.11,1.11,0,0,0,1.11,1.28c2.84,0,4.22-.21,7.8-.21,2.2,0,6.74.23,9.79.23s3.32-3,2.06-3.28c-5.63-1.22-7.8-2.91-9.64-4.51A1.84,1.84,0,0,0,152.14,408Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.67,408h-7.92a.6.6,0,0,0-.59.5L180,414.94a1.09,1.09,0,0,0,1.09,1.28c2.86,0,7-.21,10.56-.21,4.2,0,7.83.23,12.75.23,3,0,3.68-3,2.43-3.28-5.72-1.24-10.35-1.37-15.37-4.39A3.43,3.43,0,0,0,189.67,408Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.86,161.54c-6.73,1.56-13.8,20.08-13.8,20.08l14,9.34a109.25,109.25,0,0,0,8.42-15.31C163.17,167.17,157.75,160,150.86,161.54Z",
    style: {
      fill: "#F68989"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.86,161.54c-6.73,1.56-13.8,20.08-13.8,20.08l14,9.34a109.25,109.25,0,0,0,8.42-15.31C163.17,167.17,157.75,160,150.86,161.54Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.19,173.35l-5.79,17.17.66.44s2.64-3.91,5.45-9.2Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.06,193.91c-.05,8.09-.54,18.15-1.74,30.63H155.56c-.5-5.94,2.12-35-4.69-63a100,100,0,0,1,12.9-1.64,145.85,145.85,0,0,1,16.47,0,75.47,75.47,0,0,1,11.23,2s3.31,3.6,4.32,20.43C196,185.66,196.09,189.49,196.06,193.91Z",
    style: {
      fill: "#F68989"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.06,193.91c-.05,8.09-.54,18.15-1.74,30.63H155.56c-.5-5.94,2.12-35-4.69-63a100,100,0,0,1,12.9-1.64,145.85,145.85,0,0,1,16.47,0,75.47,75.47,0,0,1,11.23,2s3.31,3.6,4.32,20.43C196,185.66,196.09,189.49,196.06,193.91Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.06,193.91c-5.84,3.45-10.36-8.37-7.23-16.83l7,5.26C196,185.66,196.09,189.49,196.06,193.91Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184,167.28c-1.8,6.66,10.72,25.76,10.72,25.76l14.13-7.88a80.61,80.61,0,0,0-8.89-17.1C193.94,159.8,186,159.77,184,167.28Z",
    style: {
      fill: "#F68989"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184,167.28c-1.8,6.66,10.72,25.76,10.72,25.76l14.13-7.88a80.61,80.61,0,0,0-8.89-17.1C193.94,159.8,186,159.77,184,167.28Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.82 392.07 189.78 400.71 182.53 400.71 182.57 392.07 189.82 392.07",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "147.41 392.07 154.65 392.07 153.11 400.71 145.86 400.71 147.41 392.07",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.9,133.28c-1.94,6.94-3.43,10.9-1.26,15.7a9.35,9.35,0,0,0,16.54,1.18c3.55-5.53,6.13-16,.52-21.22A9.45,9.45,0,0,0,168.9,133.28Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.68,125.15c-3.39-.87-6.45,1.34-6.17,9.73s2.64,11,3.8,13.22,1.28.26,5.87,1.72c3.15,1,6.4-9.21,10.54-9.27,4.6-.07.67-7.79.67-7.79,1,1.65,10.89,2.77,5.11-4.65C182.38,121.54,164.21,120.33,167.68,125.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161,134.56s22.77-2.34,27.61-5.38c-.22-6.13-3.46-9.77-4.65-10.63s-11.39-1.2-13.77-.53-8.9,4.11-9.66,5.53S161,134.56,161,134.56Z",
    style: {
      fill: "#F68989"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.75,130.94c-2.49,1.86-12.6,10-25.64,8.3s3.38-5.22,3.38-5.22Z",
    style: {
      fill: "#F68989"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.75,130.94c-2.49,1.86-12.6,10-25.64,8.3s3.38-5.22,3.38-5.22Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.24,138.77a8.5,8.5,0,0,0,1.1,5.2c1.22,2.06,3,1.34,3.67-.7.59-1.83.67-5.11-1-6.48S177.5,136.62,177.24,138.77Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.57,224.54s-6.09,55.37-9.8,76.12C166.71,323.37,156.42,399,156.42,399H143.15s4-73.83,6-96.32c2.12-24.41,6.45-78.18,6.45-78.18Z",
    style: {
      fill: "#F68989"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.35,394.15c.06,0-1.17,5.1-1.17,5.1H142.25l.09-4.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.13,244.27c-9.43,1.86-7.06,37.32-5.21,55.56,2.25-12.89,5.3-37.7,7.36-55.3A3.24,3.24,0,0,0,176.13,244.27Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.32,224.54s3.09,54.17,3.15,76.27c.07,23-5.05,98.23-5.05,98.23H180.14s-3.3-73.91-4.72-96.48c-1.54-24.6-6.58-78-6.58-78Z",
    style: {
      fill: "#F68989"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.59,394.15c.06,0-.5,5.1-.5,5.1H179.16l-.58-4.55Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Post--inject-8"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "229.37 166.16 255.16 177.08 255.16 166.16 229.37 166.16",
    style: {
      fill: "#F68989"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.72,
    y: 119.62,
    width: 138.6,
    height: 195.66,
    rx: 13.54,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.16,
    y: 119.62,
    width: 138.6,
    height: 195.66,
    rx: 13.54,
    style: {
      fill: "#F68989"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.16,
    y: 177.08,
    width: 138.6,
    height: 115.49,
    style: {
      fill: "#fafafa",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.32,143.72a5.9,5.9,0,1,1,5.9-5.9A5.9,5.9,0,0,1,275.32,143.72Zm0-10.75a4.86,4.86,0,1,0,4.85,4.85A4.85,4.85,0,0,0,275.32,133Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.54,143.72a5.9,5.9,0,1,1,5.89-5.9A5.9,5.9,0,0,1,292.54,143.72Zm0-10.75a4.86,4.86,0,1,0,4.85,4.85A4.86,4.86,0,0,0,292.54,133Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.75,143.72a5.9,5.9,0,1,1,5.9-5.9A5.9,5.9,0,0,1,309.75,143.72Zm0-10.75a4.86,4.86,0,1,0,4.86,4.85A4.86,4.86,0,0,0,309.75,133Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.17,303.67a2.85,2.85,0,1,1-2.85-2.85A2.84,2.84,0,0,1,318.17,303.67Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.31,303.67a2.85,2.85,0,1,1-2.85-2.85A2.84,2.84,0,0,1,327.31,303.67Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.45,303.67a2.85,2.85,0,1,1-2.85-2.85A2.85,2.85,0,0,1,336.45,303.67Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.72,
    y: 185.64,
    width: 38.71,
    height: 38.71,
    rx: 4.16,
    style: {
      fill: "#F68989"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 283.08,
    cy: 199.42,
    r: 7.64,
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.08,210.27c-6,0-11.07,2.75-12.77,6.54a2,2,0,0,0,1.81,2.78H294a2,2,0,0,0,1.81-2.78C294.14,213,289.07,210.27,283.08,210.27Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.76,279.43H272.16a8.44,8.44,0,0,1-8.44-8.44h0a8.44,8.44,0,0,1,8.44-8.44h104.6A8.44,8.44,0,0,1,385.2,271h0A8.44,8.44,0,0,1,376.76,279.43Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.76,254.65H272.16a8.44,8.44,0,0,1-8.44-8.44h0a8.44,8.44,0,0,1,8.44-8.44h104.6a8.44,8.44,0,0,1,8.44,8.44h0A8.44,8.44,0,0,1,376.76,254.65Z",
    style: {
      fill: "#F68989",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.03,
    y: 192.82,
    width: 72.92,
    height: 5.13,
    transform: "translate(696.98 390.77) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.03,
    y: 202.43,
    width: 72.92,
    height: 5.13,
    transform: "translate(696.98 409.99) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.03,
    y: 212.04,
    width: 58.3,
    height: 5.13,
    transform: "translate(682.35 429.21) rotate(180)",
    style: {
      fill: "#fff"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlogging);
export default __webpack_public_path__ + "static/media/blogging.5fe4030df6ed7844bdd5cfd330859aee.svg";
export { ForwardRef as ReactComponent };